import _ from 'underscore';
import { useContext, useEffect, useState } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import _preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { KEYWORDS_SHOW_COUNT } from '@bingads-webui-campaign-react/search-campaign-data';

const buildSchemaData = ({
  data, serverContext, timeDisplayType, i18n,
}) => {
  const locations = _.map(
    _.filter(
      data.campaign && data.campaign.locationTargets && data.campaign.locationTargets.currentLevelSettings.currentLocations,
      loc => loc.SelectionStatus === 'Included'
    ),
    loc => loc.location
  );

  return ({
    websiteURL: {
      data: (data.websites && data.websites[0]) || i18n.getString(_TL_('No website URL')),
    },
    campaignName: {
      data: data.campaign && data.campaign.Name,
    },
    locationTargeting: {
      locations,
      targetOption: data.campaign && data.campaign.locationTargets && data.campaign.locationTargets.currentLevelSettings.targetOption,
    },
    languages: {
      data: data.campaign && data.campaign.Languages,
    },
    conversionGoals: {
      conversionGoals: data.campaign && data.campaign.conversionGoals,
    },
    keywords: {
      data: data.keywords,
      showLength: KEYWORDS_SHOW_COUNT,
    },
    budget: {
      data: data.campaign.Budget,
      currencyCode: serverContext.CurrentAccount.CurrencyCode,
    },
    bidStrategy: {
      data: data.campaign && data.campaign.BiddingScheme,
    },
    adSchedule: {
      adSchedules: data.campaign && data.campaign.dayTimeRanges,
      useSearcherTimeZone: data.campaign && data.campaign.AdScheduleUseSearcherTimeZone,
      timeDisplayType,
    },
    startEndDates: {
      startDate: data.adGroup && data.adGroup.StartDate,
      endDate: data.adGroup && data.adGroup.EndDate,
    },
    adDistribution: {
      adDistribution: data.adGroup && data.adGroup.AdDistribution,
    },
    adCreationPreview: {
      data: data.ads,
    },
  });
};

export const useSummarySchemaData = ({ data }) => {
  const i18n = useContext(I18nContext);
  const serverContext = useContext(ServerContext);
  const [timeDisplayType, setTimeDisplayType] = useState('12-hour');

  useEffect(() => {
    const preferencesService = _preferencesService.default || _preferencesService;
    preferencesService.initialize().then(() => {
      const isTwelveHourDisplay = preferencesService.findByName('WebApp.CampaignUI.isTwelveHourDisplay') || {};
      setTimeDisplayType(_.isUndefined(isTwelveHourDisplay.Data) || isTwelveHourDisplay.Data ? '12-hour' : '24-hour');
    });
  }, []);

  return (data && buildSchemaData({
    data, serverContext, timeDisplayType, i18n,
  })) || {};
};
